import { motion } from "framer-motion";
import { ArrowRight, Gamepad2, Layers, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export const PluginsPage = () => {
  const categories = [
    {
      name: "Moderation & Safety",
      icon: Zap,
      plugins: ["Moderation", "AutoMod", "Warns", "Anti-Raid", "Logging", "Server Blacklist"],
    },
    {
      name: "Community",
      icon: Layers,
      plugins: ["Leveling", "Welcome", "Reaction Roles", "Custom Commands", "Sticky Roles", "Bulk Role Management", "Tickets"],
    },
    {
      name: "Fun & Engagement",
      icon: Gamepad2,
      plugins: ["Giveaways", "Games", "Social Alerts", "Suggestions", "Advertising"],
    },
    {
      name: "Insights & AI",
      icon: Zap,
      plugins: ["Analytics", "AI Helper", "Automations"],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/30">
      <Seo
        title="Best Discord Bot Plugins: Anti-Raid, Welcome, Bulk Roles, AutoMod"
        description="Discover why NATIBOT is a best bot for Discord servers with anti-raid, AutoMod, welcome messages, bulk role management, reaction roles, automations, advertising, analytics and AI helper tools."
        keywords={[
          "best discord bot plugins",
          "best bot for discord",
          "best discord bot for servers",
          "discord bot plugins",
          "anti raid discord bot",
          "bulk role management discord",
          "welcome bot plugin",
          "automod discord plugin",
          "reaction roles plugin",
          "discord automations plugin",
        ]}
        path="/plugins"
      />
      {/* Header */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="container mx-auto max-w-6xl px-6 py-12"
      >
        <Link to="/" className="inline-block mb-6">
          <Button variant="outline" className="gap-2">
            <ArrowRight className="w-4 h-4 rotate-180" />
            Back Home
          </Button>
        </Link>
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Plugins</h1>
        <p className="text-xl text-muted-foreground max-w-2xl">
          32+ plugin modulari per ogni esigenza
        </p>
      </motion.div>

      {/* Plugin Categories */}
      <div className="container mx-auto max-w-6xl px-6 py-12">
        {categories.map((cat, idx) => {
          const Icon = cat.icon;
          return (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="mb-8"
            >
              <div className="flex items-center gap-3 mb-4">
                <Icon className="w-6 h-6 text-primary" />
                <h2 className="text-2xl font-bold">{cat.name}</h2>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {cat.plugins.map((plugin) => (
                  <div key={plugin} className="glass-card p-4 rounded-lg text-center">
                    {plugin}
                  </div>
                ))}
              </div>
            </motion.div>
          );
        })}
      </div>

      {/* CTA */}
      <div className="container mx-auto max-w-6xl px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-4">Attiva i Plugin che Vuoi</h2>
        <Link to="/dashboard">
          <Button size="lg" className="gap-2">
            Vai al Dashboard
            <ArrowRight className="w-4 h-4" />
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PluginsPage;
